// Coordinated beta build label. Surfaced in the footer (index.html/new.html)
// and logged at startup so field reports can be tied to a specific build.
const SCN_BUILD_LABEL = "B2026.07A";
console.info("[dispatch] SCN Dispatch build " + SCN_BUILD_LABEL);

const LOCAL = false;

// Audio path: 'v2' (legacy MediaRecorder/decodeAudioData via JS signaling server)
// or 'v3' (Rubidium IMBE + AES-CTR via TS signaling server). Driven by the
// `audioVersion` field on the view config (written via USM). Read by voice.js
// (the lazy router). 'v2' is the safe default until getConfiguration() loads
// the view config and overrides this — the router resolves the class lazily,
// so the override is picked up as long as it lands before the first
// new Voice(...) call (which happens after `await getConfiguration()`).
window.__SCN_AUDIO_VERSION = 'v2';

async function getServerForKey(key)
{
    console.log("Getting server for key")
    try {
        if(LOCAL)
        {
            return "http://localhost:8080"
        }
        let response = await axios.get("https://director.scncomms.app/api/getZoneController", {
            params: {
                key: key
            }
        })
        return `https://${response.data}`;
    }
    catch(e)
    {
        console.error(`Error occurred while attempting to get server info. Error: [${e}]`)
    }
}

let globalSocket = undefined;
let socketAddr = "main-1.cc.p25.scncomms.app";
let systemKey = "E826968B5607D38E021E4254D39A9017";
let webRadioID = 27000;
// Rev 7 alias source — view-config override; "DISPATCH" default. Combined with
// the (offset+1) from console_activate_ok to produce the per-session label
// stamped on every outbound v3_packet / systemTone / tone_start payload.
let consoleAliasLabel = "DISPATCH";
let configChannels = [
    {id: 27101,name: "27 RDC DISP"},
    {id: 27102,name: "27 RDC RCRD"},
    {id: 27111,name: "27 RDC TAC 1"},
    {id: 27112,name: "27 RDC TAC 2"},
    {id: 27701,name: "27 FIRE DISP"}
];
let configTones = [
    {
        type:"QCII",
        tone1:112,
        tone2:154,
        name:"27 ST12",
        tgID:27701
    },
    {
        type:"QCII",
        tone1:138,
        tone2:161,
        name:"27 ST13",
        tgID:27701
    },
    {
        type:"QCII",
        tone1:159,
        tone2:201,
        name:"27 ST43",
        tgID:27701
    },
    {
        type:"QCII",
        tone1:156,
        tone2:193,
        name:"27 ST44",
        tgID:27701
    }
]

let channelTones = [
    {
        toneIcon: "SOLID",
        toneText: "ATTN",
        toneID: "A"
    },
    {
        toneIcon: "INTERVAL",
        toneText: "ALRT",
        toneID: "B"
    },
    {
        toneIcon: "WAVERING",
        toneText: "EVAC",
        toneID: "C"
    }
]
let loadingDiag = $.dialog({
    lazyOpen: true,
    title: 'Loading...',
    content: 'Loading Configuration...',
    type: 'blue',
    infinite: true
});

let loginDiag = $.dialog({
    lazyOpen: true,
    title: 'Login Required',
    content: 'Login is required to load this console. Please allow pop-ups and log in to continue.',
    type: 'orange'
});

let loginFailedDiag = $.dialog({
    lazyOpen: true,
    title: 'Login Failed',
    content: 'Login to this panel failed',
    type: 'red'
});
let configGroups = [];
function addScript( src ) {
    let s = document.createElement( 'script' );
    s.setAttribute( 'src', src );
    document.body.appendChild( s );
}


async function waitForLogin()
{
    loadingDiag.close();
    loginDiag.open();
    window.open("https://login.scncomms.app/login");
    let user = undefined;
    let awaitLogin = async function()
    {
        return new Promise(innerResolve => {
            var interval = setInterval(async ()=>{
                let updatedUser = undefined;
                try{
                    updatedUser = (await axios.get("https://login.scncomms.app/api/user/",{
                        method:"get",
                        withCredentials:true
                    })).data;
                }
                catch(e)
                {

                }
                if(updatedUser!==undefined) {
                    clearInterval(interval);
                    innerResolve(updatedUser);
                }
            },1000)
        })
    }
    user = await awaitLogin();
    loginDiag.close();
    return user;
}

async function getSecuredConsoleConfiguration()
{
    try {
        let user = undefined;
        try {
            user = await axios.get("https://login.scncomms.app/api/user/", {method: "get", withCredentials: true});
        } catch (e) {

        }
        if (user == undefined) {
            user = await waitForLogin();
        }
        let handshakeCode = (await axios.get("https://api.gen2.radio.scncomms.app/api/secure/login/init", {
            method: "get",
            withCredentials: true
        })).data;
        let responseCode = (await axios.get(`https://login.scncomms.app/api/submitVerifyReq/${handshakeCode}`, {
            method: "get",
            withCredentials: true
        })).data;
        let finalizedLogin = (await axios.get(`https://api.gen2.radio.scncomms.app/api/secure/login/verify?code=${responseCode}`, {
            method: "get",
            withCredentials: true
        })).data;
        let config = (await axios.get(`https://api.gen2.radio.scncomms.app/api/secure/config?viewKey=${new URLSearchParams(window.location.search).get('view')}`, {
            method: "get",
            withCredentials: true
        })).data;
        return config;
    }
    catch(e)
    {
        console.error("Error while logging in",e);
        loginFailedDiag.open();
    }
}

async function getConfiguration()
{
    $("#console").hide();
    const urlParams = new URLSearchParams(window.location.search);
    const view = urlParams.get('view');
    const desktop = urlParams.get('desktop');
    if (desktop !== null) {
        addScript("./dist/desktop.js")
    }

    if(view!=null)
    {
        let result = await $.ajax(`https://scnp25-desktop-autoconfig.scncomms.app/view/${view}.json`);
        if(result.shadow == true) {
            result = await getSecuredConsoleConfiguration();
        }
        console.log(result);
        configChannels = result.channels;
        configTones = result.tones;
        if(result.groups!=undefined)
        {
            configGroups = result.groups;
        }
        webRadioID = result.sysID;
        systemKey = result.key;
        // audioVersion is set per-server via USM (admin label: "Enhanced Voice").
        // Missing/falsy value defaults to v2. Voice.js is a late-binding router,
        // so this assignment lands before any new WebRadio (and therefore any
        // new Voice) is constructed below. NOT the same field as the deprecated
        // CAIVoiceMetadata.enhancedVoice flag — that one is wire-protocol layer
        // and gone in Phase 7.
        if (result.audioVersion === "v3") {
            window.__SCN_AUDIO_VERSION = "v3";
            console.info("[dispatch] audioVersion=v3 from view config (Enhanced Voice enabled)");
        } else {
            window.__SCN_AUDIO_VERSION = "v2";
        }
        if (typeof result.consoleAliasLabel === "string" && result.consoleAliasLabel.length > 0) {
            consoleAliasLabel = result.consoleAliasLabel;
        }
        socketAddr = await getServerForKey(systemKey);
        console.log(`Got socketaddr: ${socketAddr}`)
        if(result.socketAddr!=undefined)
        {
            socketAddr = result.socketAddr;
        }
    }
    $("#console").show();
    setTimeout(()=>{
        $('.tabs').tabs();
    },500)
}

function getToneForEvent(e)
{
    return getToneForID(e.currentTarget.parentElement.dataset.tgId,e.currentTarget.parentElement.dataset.type,e.currentTarget.parentElement.dataset.tone1,e.currentTarget.parentElement.dataset.tone2)
}

function getToneForID(tgID,type,tone1,tone2)
{
    for (const t of webconsole.tones)
    {
        if (t.tgID === tgID && t.type === type && t.tone1 === tone1 && t.tone2 === tone2)
        {
            return t;
        }
    }
}



class Tone {
    group;
    name;
    tgID;
    type;
    tone1;
    tone2;
    consoleSession;   // Rev 7: single shared session replaces per-Tone pagingRadio
    that;
    queued;
    tx;
    playSingleTone = async () =>
    {
        this.tx = true;
        try {
            // QCII paging stays on `systemTone` per Rev 7, but emits with the
            // console RID (per-channel RID under v2_legacy) and the target TG
            // in the payload. Local playback only if the tone actually went out.
            const sent = await this.consoleSession.broadcastSystemTone(this.tgID, this.type, this.tone1, this.tone2);
            if(sent && this.type === "QCII") {
                Tones.generateQuikCallPage(this.tone1, this.tone2);
                await Helper.sleep(4000);
            } else if(sent) {
                Tones.playAlertTone(this.type);
                await Helper.sleep(this.type === "HOLD" ? 1000 : 4000);
            }
        }
        catch(e) {
            console.log("Error while playing tone")
            console.log(e)
        }
        this.tx = false;
    }

    playTone = async () => {
        webconsole.tonesPlaying = true;
        for (const item of webconsole.tones) {
            if(item.queued || (item.tgID === this.tgID && item.type === this.type && item.tone1 === this.tone1 && item.tone2 === this.tone2))
            {
                item.queued = false;
                await Helper.sleep(1)
                await item.playSingleTone();
                await Helper.sleep(500);
            }
        }
        webconsole.tonesPlaying = false;
    }

    addToMultipage = () => {
        this.queued = !this.queued;
    }

    constructor(name,tgID,type,tone1,tone2,group,consoleSession)
    {
        this.that = this;
        this.name = name;
        this.type = type;
        this.tgID = tgID;
        this.tone1 = tone1;
        this.tone2 = tone2;
        this.group = group;
        this.consoleSession = consoleSession;
        this.queued = false;
        this.tx = false;
    }
}

class Channel {
    currentAlias;
    currentSubscriber;     // updated per-frame by handleVoiceMetadata for mid-call talker swap
    radioID;               // Rev 7: == consoleSession.consoleRid (resolved at session-active)
    encryptionkey;
    group;
    tgID;
    name;
    key;
    status;
    monitored;
    tx;
    rx;
    emg;
    consoleSession;        // Rev 7: replaces per-channel WebRadio
    voice;                 // Per-channel Voice (created on monitor-on)
    toneText;
    toneID;
    toneIcon;
    held;
    preemptTx;             // Rev 7: true while transmitting as a preempt over a radio call
    // Rev 8 channel_preempt_ok enrichment — set during the preempt-TX window
    // so the tile can render "Preempting <alias>" / "RID <rid>" subtext.
    // Cleared on PTT release.
    displacedRid;
    displacedAlias;
    // Rev 7 follow-up dropped the consoles-only fanout indicator — other
    // consoles don't know about radio-into-preempt audio; it's private to
    // the preempting console via the incoming-subscriber-call path.
    incomingSubCalls;      // IncomingSubscriberCall instances for this TG
    expanded;
    callList;
    ptt;
    hold;
    constructor(tgID,name,key,group,encryptionkey,radioID,expanded,consoleSession) {
        this.radioID=radioID;
        this.encryptionkey=encryptionkey;
        this.group=group;
        this.tgID=tgID;
        this.name=name;
        this.key=key;
        this.status= "OFFLINE";
        this.monitored= false;
        this.tx=false;
        this.rx=false;
        this.emg=0;
        this.consoleSession=consoleSession;
        this.voice=undefined;
        this.toneText="ATTN";
        this.toneID="A";
        this.toneIcon="SOLID";
        this.held=false;
        this.preemptTx=false;
        this.displacedRid=undefined;
        this.displacedAlias=undefined;
        this.incomingSubCalls=[];
        this.ptt=false;
        this.hold=false;
        this.expanded=expanded;
        this.callList=[{"radioID":"","type":""},{"radioID":"","type":""},{"radioID":"","type":""},{"radioID":"","type":""},{"radioID":"","type":""},{"radioID":"","type":""},{"radioID":"","type":""},{"radioID":"","type":""},{"radioID":"","type":""},{"radioID":"","type":""}];
    }

    addToCallList(radioID,type)
    {
        this.callList.unshift({
            radioID: radioID,
            type:type
        })
        while(this.callList.count>10)
        {
            this.callList.pop();
        }
    }

    eventCallback = async (eventData) =>{
        if(eventData.id === "rx")
        {
            this.currentSubscriber = eventData.subscriber;
            this.rx = true;
            this.addToCallList(eventData.subscriber,"Voice Call")
            while(this.rx === true)
            {
                // Read this.currentSubscriber every loop so a mid-call talker
                // swap (radio→console after a preempt, or one radio handing to
                // another) reflects in the displayed RID. handleVoiceMetadata
                // mutates this.currentSubscriber as v3 frames arrive.
                if(this.currentAlias===undefined) {
                    this.status = `Rx ${this.currentSubscriber}`;
                }
                else
                {
                    this.status = `Rx ${this.currentAlias}`;
                }
                await Helper.sleep(200);
            }
        }
        else if(eventData.id === "tx")
        {
            if(eventData.status === true)
            {
                this.status = this.preemptTx ? `Tx (preempt)` : `Tx`;
            }
            else
            {
                this.status = "ONLINE";
            }
            this.tx = eventData.status;
        }
        else if(eventData.id === "release")
        {
            this.rx = false;
            if(this.currentAlias===undefined) {
                this.status = `LC ${this.currentSubscriber}`;
            }
            else
            {
                this.status = `LC ${this.currentAlias}`;
            }
            this.currentAlias = undefined;
            this.currentSubscriber = undefined;
        }
        else if(eventData.id === "emerg")
        {
            webconsole.emergencyMuted = false;
            this.emg = eventData.subscriber;
            this.addToCallList(eventData.subscriber,"Emergency Alarm")
            while(this.emg === eventData.subscriber)
            {
                this.status = `Emergency ${eventData.subscriber}`;
                await Helper.sleep(5000);
                this.status = "ONLINE";
                await Helper.sleep(5000);
            }
        }
        else if(eventData.id === "emerg_clear")
        {
            this.emg = 0;
            this.status = `ONLINE`;
        }
        webconsole.forceUpdate();
    };

    // Per-frame voice metadata from VoiceV3 — surfaces alias AND per-frame
    // subscriberID. The latter drives the Rev 7 mid-call talker swap: when a
    // console preempts a radio mid-call, the receiver's display switches from
    // the radio RID to the new (console or otherwise) RID without a
    // CHANNEL_REL_ANNOUNCE.
    //
    // Order matters: process subscriberID first (which clears the *previous*
    // talker's alias) so that THIS frame's alias (if non-empty) survives and
    // replaces it. If subscriberID changes and this frame's alias is empty
    // (FiveM radios, dispatch radios that don't stamp it), the status loop
    // falls back to `Rx ${currentSubscriber}` — which is the explicit Rev 7
    // RID-fallback behavior.
    handleVoiceMetadata = (metadata) => {
        if(!metadata) { return; }
        let changed = false;
        if(metadata.subscriberID !== undefined && metadata.subscriberID !== null) {
            if(this.currentSubscriber !== metadata.subscriberID) {
                this.currentSubscriber = metadata.subscriberID;
                this.currentAlias = undefined;
                changed = true;
            }
        }
        // Empty string is treated as "no alias on this frame" — matches the
        // FiveM `voiceAlias != ""` check, and lets the RID fallback engage.
        if(metadata.alias !== undefined && metadata.alias !== null && metadata.alias !== "") {
            if(this.currentAlias !== metadata.alias) {
                this.currentAlias = metadata.alias;
                changed = true;
            }
        }
        if(changed) {
            if(typeof webconsole !== "undefined" && webconsole && webconsole.forceUpdate) {
                webconsole.forceUpdate();
            }
        }
    };

    // ConsoleSession listeners — forward TG-scoped events into eventCallback.

    onChannelAnnounceForTG = (packet) => {
        if(!this.monitored) { return; }
        if(packet.messageKey === undefined) { return; }
        if(packet.messageKey.toString() !== this.tgID.toString()) { return; }
        if(this.ptt) { return; }
        const inner = this.consoleSession.buildChannelInner(packet.payload, this.encryptionkey);
        const vcName = "vc[" + inner + "]";
        if(this.voice && this.voice.currentChannel === vcName) {
            return; // already on this channel
        }
        if(this.voice) {
            if(typeof this.voice.setEncryptionKey === "function") {
                this.voice.setEncryptionKey(vcName, this.encryptionkey);
            }
            // Rev 8: pass joinedTg so VoiceV3 can validate inbound frames /
            // heartbeats / stream-transitions against this TG. Mismatch
            // leaves the vc immediately (catches vc-recycle-mid-hangtime).
            // serverRev8 gates strict targetTalkgroup validation — only true
            // when the signaling server echoed "v1.1" on activate_ok.
            this.voice.setVoiceChannel(inner, this.tgID, this.consoleSession && this.consoleSession.serverRev8);
        }
        this.eventCallback({ id: "rx", subscriber: packet.target });
    };

    onChannelReleaseAnnounceForTG = (packet) => {
        if(!this.monitored) { return; }
        if(packet.messageKey === undefined) { return; }
        if(packet.messageKey.toString() !== this.tgID.toString()) { return; }
        setTimeout(() => {
            if(this.voice) { this.voice.leaveVoiceChannel(); }
            this.eventCallback({ id: "release" });
        }, 2000);
    };

    // Rev 7 follow-up: a radio TXing back into a TG we're preempting arrives
    // here as a private incoming-subscriber call. Render it as a small panel
    // on this tile with mute/volume controls; audio is on a dedicated second
    // pipeline so volume isn't tangled with the main TG audio path.
    onIncomingSubscriberCallForTG = (data, call) => {
        if(!data || data.talkgroup !== this.tgID) { return; }
        this.incomingSubCalls = this.incomingSubCalls.concat([call]);
        webconsole.forceUpdate && webconsole.forceUpdate();
    };

    onIncomingSubscriberCallEndedForTG = (data) => {
        if(!data || data.talkgroup !== this.tgID) { return; }
        const radioRid = data.radioRid;
        this.incomingSubCalls = this.incomingSubCalls.filter(c => c.radioRid !== radioRid);
        webconsole.forceUpdate && webconsole.forceUpdate();
    };

    onEmergencyForTG = (data) => {
        if(!data || data.talkgroup !== this.tgID) { return; }
        this.eventCallback({ id: "emerg", subscriber: data.subscriber });
    };

    onEmergencyClearForTG = (data) => {
        if(!data || data.talkgroup !== this.tgID) { return; }
        this.eventCallback({ id: "emerg_clear" });
    };

    toggleMonitor = async (e)=>{
        try {
            console.log(`Toggle monitor ${this.tgID}`);
            this.monitored = !this.monitored;
            if(this.monitored) {
                // Rev 7: console session already affiliates to all view TGs at
                // activate time. Monitor toggle is now a per-channel audio-
                // routing decision: create a Voice instance and let it join the
                // vc[] room when an inbound CHANNEL_ANNOUNCE for this TG arrives.
                if(!this.voice) {
                    this.voice = new Voice(globalSocket);
                    this.voice.setSubscriber(this.consoleSession.consoleRid);
                    if(typeof this.voice.setAlias === "function") {
                        this.voice.setAlias(this.consoleSession.consoleAlias);
                    }
                    this.voice.cbVoiceMetadata = this.handleVoiceMetadata;
                }
                this.radioID = this.consoleSession.consoleRid;
                this.status = "ONLINE";
                refreshChannelAudio();
            } else {
                if(this.voice) {
                    try { this.voice.leaveVoiceChannel(); } catch(_) {}
                    this.voice = undefined;
                }
                this.status = "OFFLINE";
                this.rx = false;
                // Tear down any incoming-subscriber audio paths visible on
                // this tile when the dispatcher disables monitor.
                for(const call of this.incomingSubCalls) {
                    try { call.teardown(); } catch(_) {}
                }
                this.incomingSubCalls = [];
            }
        }
        catch(e)
        {
            console.warn("Error toggling monitor");
            console.warn(e);
        }
    };
    playToneWebPanel= async (e,talkgroup,key)=> {
        console.log(`Broadcast tone on ${talkgroup} : ${this.toneID}`);
        // Rev 7: tone path goes through the single console session. No
        // per-channel grant hop — server fans audio to the affiliated TG.
        // Local playback only if the tone actually went out — otherwise the
        // dispatcher hears a tone the channel never got (the bonk already
        // signalled the failure).
        if(await this.consoleSession.broadcastSystemTone(this.tgID, this.toneID, "", "")) {
            Tones.playAlertTone(this.toneID);
        }
    };
    // v3 hold-to-talk attention-tone state. Underscore-prefixed so Vue 2
    // doesn't observe them — they're plain bookkeeping, not template-bound.
    _holdTimer = null;
    _keepaliveTimer = null;
    _currentStreamId = null;
    // v2 fallback: tracks a press waiting for its matching mouseup so we can
    // emulate legacy `click` semantics without the hold-to-talk state machine.
    _tapPending = false;

    _generateStreamId = () => {
        if(typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
            return crypto.randomUUID();
        }
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
            const r = Math.random() * 16 | 0;
            const v = c === "x" ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };

    // Local synth Hz lookup for the attention-tone hold-to-talk path. This is
    // ONLY for the dispatcher's own Web Audio playback while held — the wire
    // (tone_start) doesn't carry Hz, it carries the toneID as `type`. Mirrors
    // ConsoleSession.synthFreqForToneType so emitter and receiver match.
    _localSynthHzForToneID = (toneID) => {
        return ConsoleSession.synthFreqForToneType(toneID, 0, 0) || 900;
    };

    _cleanupSustainedTone = () => {
        if(this._keepaliveTimer) {
            clearInterval(this._keepaliveTimer);
            this._keepaliveTimer = null;
        }
        if(this._currentStreamId) {
            try { Tones.stopSustainedTone(this._currentStreamId); } catch(_e) {}
            try {
                if(this.consoleSession) {
                    this.consoleSession.broadcastToneStop(this._currentStreamId);
                }
            } catch(_e) {}
            this._currentStreamId = null;
        }
        this.held = false;
        this.tx = false;
    };

    startToneHold = (e) => {
        // Only react to primary (left) button presses.
        if(e && typeof e.button === "number" && e.button !== 0) { return; }
        if(!this.monitored) { return; }

        // Hold-to-talk requires the v3 wire protocol. On v2 views, fall back
        // to legacy click semantics: mark a pending tap and fire the
        // fixed-duration systemTone on the matching mouseup. No 250ms timer,
        // no held UX, no tone_start emit.
        if(window.__SCN_AUDIO_VERSION !== "v3") {
            this._tapPending = true;
            return;
        }

        if(this._holdTimer || this._currentStreamId) { return; }
        this.tx = true;
        this._holdTimer = setTimeout(() => {
            this._holdTimer = null;
            try {
                const streamId = this._generateStreamId();
                const synthHz = this._localSynthHzForToneID(this.toneID);
                this._currentStreamId = streamId;
                this.held = true;
                // Local synth uses Hz; wire uses the toneID as `type` with
                // tone1=tone2=0 (server validates type required + non-QCII
                // tolerates zero ints).
                Tones.startSustainedTone(streamId, synthHz);
                if(this.consoleSession) {
                    this.consoleSession.broadcastToneStart(streamId, this.tgID, this.toneID, 0, 0);
                }
                this._keepaliveTimer = setInterval(() => {
                    if(this._currentStreamId && this.consoleSession) {
                        this.consoleSession.broadcastToneKeepalive(this._currentStreamId);
                    }
                }, 2000);
            } catch(err) {
                console.warn("Error starting sustained tone", err);
                this._cleanupSustainedTone();
            }
        }, 250);
    };

    endToneHold = async (e) => {
        // v2 fallback path: only mouseup on the button itself fires the tone.
        // mouseleave just discards the pending tap, matching native `click`
        // semantics (down-then-up-elsewhere is a cancel, not a click).
        if(this._tapPending) {
            const isMouseLeave = e && e.type === "mouseleave";
            this._tapPending = false;
            if(isMouseLeave) { return; }
            try {
                await this.playToneWebPanel(e, this.tgID, this.key);
            } catch(err) {
                console.warn("Error firing tap tone", err);
            }
            return;
        }

        // v3 short-tap path: timer still pending => cancel and fire the legacy
        // fixed-length systemTone, matching pre-v3 behavior.
        if(this._holdTimer) {
            clearTimeout(this._holdTimer);
            this._holdTimer = null;
            this.tx = false;
            try {
                await this.playToneWebPanel(e, this.tgID, this.key);
            } catch(err) {
                console.warn("Error firing short-tap tone", err);
            }
            return;
        }
        // v3 hold path: kill keepalive, emit stop, drop local audio.
        if(this._currentStreamId) {
            this._cleanupSustainedTone();
        }
    };

    setToneWebPanel=(e,talkgroup,key)=>
    {
        this.toneIcon = e.target.dataset.toneIcon;
        this.toneText = e.target.dataset.toneText;
        this.toneID = e.target.dataset.toneId;
        console.log(`Set tone on ${talkgroup} to ${this.toneID}`)
    };
    clearEmergency=(e)=>
    {
        console.log(`Clear emergency on TG ${this.tgID}`);
        this.consoleSession.forceClearEmergency(this.tgID);
        this.emg = 0;
    };
    togglePrimary=(e)=>
    {
        try {
            let radioID = this.radioID;
            console.log(`Toggle primary to ${radioID}`);
            webconsole.primary = radioID;
        }
        catch(e)
        {
            console.warn("Error toggling PTT");
            console.warn(e);
        }
    };
    togglePTT=async (e)=>{
        try {
            console.log(`Toggle PTT ${this.tgID}`);
            this.ptt = !this.ptt;
            if (this.ptt) {
                // Allow PTT in "active" (Rev 7+ session) or "v2_legacy" (pre-
                // Rev-7 fallback). Anything else (idle, activating, failed,
                // pool_exhausted, deactivating) bonks.
                const sessionState = this.consoleSession && this.consoleSession.state;
                if(sessionState !== "active" && sessionState !== "v2_legacy") {
                    this.ptt = false;
                    Tones.generateBonk();
                    return;
                }
                const result = await this.consoleSession.requestTx(this.tgID);
                if(result.status === "granted" || result.status === "granted_preempt") {
                    this.preemptTx = (result.status === "granted_preempt");
                    // Rev 8 preempt path: server hands back the fully-formed
                    // preemptVc as an opaque `vc[...]` string. Console TXes
                    // directly into it — no second CHANNEL_REQ round-trip,
                    // no buildChannelInner wrap (would double-bracket). The
                    // server bridges these frames into the TG vc where
                    // listeners + the displaced radio are joined.
                    if(this.preemptTx) {
                        this.displacedRid = result.displacedRid;
                        this.displacedAlias = result.displacedAlias;
                        if(this.voice && typeof result.preemptVc === "string" && result.preemptVc.length > 0) {
                            // preemptVc is the full "vc[<sysKey>:<tg>:preempt-<sid>]" string.
                            // setVoiceChannel takes the inner (without the "vc[…]" wrap),
                            // so peel the brackets back off for the call into Voice.
                            const inner = (result.preemptVc.startsWith("vc[") && result.preemptVc.endsWith("]"))
                                ? result.preemptVc.slice(3, -1)
                                : result.preemptVc;
                            // Key on the TG (not on the preempt room) — the preempt audio
                            // is the same TG's encryption material; server doesn't see keys.
                            if(typeof this.voice.setEncryptionKey === "function") {
                                this.voice.setEncryptionKey("vc[" + inner + "]", this.encryptionkey);
                            }
                            // Rev 8 §3.11: stamp targetTalkgroup on outbound frames.
                            // For preempt TX, source is channel_preempt_ok.talkgroup
                            // (== this.tgID, the TG we requested preempt on).
                            if(typeof this.voice.setTalkgroup === "function") {
                                this.voice.setTalkgroup(this.tgID);
                            }
                            // Rev 8: joinedTg for the preempt-vc is the underlying
                            // TG. Server bridges console frames back onto the TG
                            // vc stamped with targetTalkgroup = tgID, so the
                            // preempting console's own decoder (if it ever sees
                            // bridged frames echoed — currently filtered server-
                            // side via socket.to() exclusion) validates cleanly.
                            this.voice.setVoiceChannel(inner, this.tgID, this.consoleSession && this.consoleSession.serverRev8);
                            this.voice.setPTT(true);
                        }
                    } else {
                        this.displacedRid = undefined;
                        this.displacedAlias = undefined;
                        if(this.voice && result.channelID !== undefined && result.channelID !== null) {
                            const inner = this.consoleSession.buildChannelInner(result.channelID, this.encryptionkey);
                            const vcName = "vc[" + inner + "]";
                            if(typeof this.voice.setEncryptionKey === "function") {
                                this.voice.setEncryptionKey(vcName, this.encryptionkey);
                            }
                            if(typeof this.voice.setAccessibilityListenersPresent === "function") {
                                this.voice.setAccessibilityListenersPresent(result.accessibilityListenersPresent === true);
                            }
                            // Rev 8 §3.11: stamp targetTalkgroup on outbound. Normal-grant
                            // path source is Channel.tgID (the TG the operator is on).
                            if(typeof this.voice.setTalkgroup === "function") {
                                this.voice.setTalkgroup(this.tgID);
                            }
                            // Rev 8: joinedTg = this.tgID for normal TX (our own
                            // frames echo back via standard fanout but server's
                            // socket.to() excludes the emitter; defensive in any
                            // case for the rare future server change).
                            this.voice.setVoiceChannel(inner, this.tgID, this.consoleSession && this.consoleSession.serverRev8);
                            this.voice.setPTT(true);
                        }
                    }
                    Tones.generatePTT(true);
                    this.tx = true;
                    this.status = this.preemptTx ? "Tx (preempt)" : "Tx";
                } else {
                    this.ptt = false;
                    Tones.generateBonk();
                }
            } else {
                if(this.voice) {
                    try { this.voice.setPTT(false); } catch(_) {}
                    // Rev 8 §3.11: clear the outbound TG stamp so subsequent
                    // frames (none expected after setPTT(false), but defensive)
                    // don't carry a stale TG.
                    if(typeof this.voice.setTalkgroup === "function") {
                        try { this.voice.setTalkgroup(0); } catch(_) {}
                    }
                }
                this.preemptTx = false;
                this.displacedRid = undefined;
                this.displacedAlias = undefined;
                this.tx = false;
                this.status = "ONLINE";
                if(this.consoleSession) {
                    this.consoleSession.releaseTx(this.tgID);
                }
            }
        }
        catch(e)
        {
            console.warn("Error toggling PTT");
            console.warn(e);
        }
    };
    toggleHold=(e)=>{
        // Channel-hold (10s-interval HOLD broadcast) is a pre-Rev 7 feature
        // that ran a loop inside WebRadio. Rev 7 removed that loop. Until the
        // server side adds a console-driven channel-hold equivalent, this is a
        // local UI-only toggle that fires a single HOLD systemTone immediately.
        try{
            const next = !this.hold;
            this.hold = next;
            if(next && this.consoleSession) {
                // Fire-and-forget (this is a UI toggle, not an async handler),
                // but still gate local playback on the broadcast actually
                // going out, and swallow rejection so it can't surface as an
                // unhandled promise.
                this.consoleSession.broadcastSystemTone(this.tgID, "HOLD", "", "")
                    .then(sent => { if(sent) { Tones.playAlertTone("HOLD"); } })
                    .catch(() => {});
            }
            webconsole.forceUpdate();
        }
        catch(e)
        {
            console.warn("Error toggling channel hold");
            console.warn(e);
        }
    }
    setTone=(e)=>
    {
        this.setToneWebPanel(e,this.tgID,this.key)
    };
    broadcastTone=async (e)=>
    {
        await this.playToneWebPanel(e,this.tgID,this.key)
    }
}


function getTone(name, tgID, type, tone1, tone2, group, consoleSession) {
    return new Tone(name, tgID, type, tone1, tone2, group, consoleSession)
}

function getChannel(tgID,name,key,group,encryptionkey,radioID,expanded=false,consoleSession=undefined)
{
    return new Channel(tgID,name,key,group,encryptionkey,radioID,expanded,consoleSession);
}

let webconsole;


async function getPatches()
{
    return new Promise((resolve) => {
        globalSocket.emit('getPatches', systemKey, (status, result) => {
            if(status === "OK" && result) {
                // Parse bidirectional patches into unique patch groups
                webconsole.patches = parsePatchGroups(result);
                console.log("Loaded patches:", webconsole.patches);
                resolve();
            } else {
                resolve();
            }
        });
    });
}

function parsePatchGroups(rawPatches) {
    // Parse bidirectional patches into unique groups
    const patchMap = new Map();

    for(const patch of rawPatches) {
        const tg1 = patch.tg1;
        const tg2 = patch.tg2;

        // Create a unique key for this pair (sorted to treat bidirectional as same)
        const key = [tg1, tg2].sort((a,b) => a-b).join('-');

        if(!patchMap.has(key)) {
            patchMap.set(key, {
                talkgroups: new Set([tg1, tg2]),
                primaryTg: tg1  // Store the first tg1 we see as the primary
            });
        } else {
            // Add to existing patch group
            const group = patchMap.get(key);
            group.talkgroups.add(tg1);
            group.talkgroups.add(tg2);
        }
    }

    // Convert to array of patch groups
    return Array.from(patchMap.values()).map(group => ({
        talkgroups: Array.from(group.talkgroups),
        primaryTg: group.primaryTg
    }));
}

async function addPatch(webKey, patchObj, callback) {
    globalSocket.emit('addPatch', webKey, patchObj, (status) => {
        if(callback) callback(status);
    });
}

async function removePatch(webKey, patchObj, callback) {
    globalSocket.emit('removePatch', webKey, patchObj, (status) => {
        if(callback) callback(status);
    });
}

async function resetPatches(webKey, callback) {
    globalSocket.emit('resetPatches', webKey, (status) => {
        if(callback) callback(status);
    });
}

function refreshChannelAudio()
{
    if(webconsole.config.unselectAudioSeperate)
    {
        let index = 0;
        for (const c of webconsole.channels) {
            if(index === webconsole.primary)
            {
                // primary
                if(c.voice !== undefined)
                {
                    if(webconsole.config.primarySpeaker!==null)
                    {
                        c.voice.setAudioDevice(undefined)
                    }
                    else {
                        c.voice.setAudioDevice(webconsole.config.primarySpeaker)
                    }
                }
            }
            else
            {
                // secondary
                if(c.voice !== undefined)
                {
                    if(webconsole.config.unselectSpeaker!==null)
                    {
                        c.voice.setAudioDevice(undefined)
                    }
                    else {
                        c.voice.setAudioDevice(webconsole.config.unselectSpeaker)
                    }
                }
            }
        }
    }
    else
    {
        console.debug(webconsole.config.primarySpeaker)
        for (const c of webconsole.channels) {
            if(c.voice !== undefined)
            {
                if(webconsole.config.primarySpeaker===null)
                {
                    c.voice.setAudioDevice(null)
                }
                else {
                    c.voice.setAudioDevice(webconsole.config.primarySpeaker)
                }
            }
        }
    }
}



// Rev 7: single console session for the dispatcher. Replaces the pre-Rev-7
// 16-channel-radio model + sysID+1 toning radio. Exposed at module scope so
// the beforeunload deactivate handler at the bottom of the file can reach it.
let consoleSession;

async function initialSetup()
{
    loadingDiag.open();
    await getConfiguration();

    globalSocket = io(socketAddr);
    await Helper.sleep(100);

    // Check for force patches parameter
    const urlParams = new URLSearchParams(window.location.search);
    const forcePatches = urlParams.get('forcePatches');

    // Check server capabilities
    let patchingEnabled = false;

    if(forcePatches !== null) {
        patchingEnabled = true;
        console.log("Patching functionality force enabled via URL parameter");
    } else {
        globalSocket.emit('announceCapabilities', (capabilities) => {
            if(capabilities && capabilities.patch === true) {
                patchingEnabled = true;
                console.log("Patching functionality enabled");
            }
        });

        // Wait for capability response
        await Helper.sleep(200);
    }

    // Compute the TG list the console will affiliate to. This is the union of
    // all channels + tones in the view config — the console needs to be on the
    // TG to TX (CHANNEL_REQ / channel_preempt / systemTone / tone_start).
    const affiliateTGs = new Set();
    for(const c of configChannels) { affiliateTGs.add(c.id); }
    if(configTones) {
        for(const t of configTones) { affiliateTGs.add(t.tgID); }
    }
    const talkgroupsList = Array.from(affiliateTGs);

    // tg -> per-TG voice encryption key from view config. Server never sees
    // these (keys are client-side only, SHA-256 of human strings); the
    // ConsoleSession uses this map to resolve the key locally when an
    // incoming_subscriber_call arrives for a preempted TG.
    const tgKeyMap = new Map();
    for(const c of configChannels) {
        tgKeyMap.set(c.id, c.encryptionkey !== undefined ? c.encryptionkey : null);
    }

    consoleSession = new ConsoleSession(globalSocket, {
        sysID: webRadioID,
        systemKey: systemKey,
        talkgroups: talkgroupsList,
        // Rev 8: stable per-instance identity UUID. Generated once per
        // session-object construction (which itself is once per page-load),
        // sent on every console_activate so the server-side hold window
        // (B2026.05H, 120s) can restore the same RID after a wire blip.
        // Per Desktop pattern: NOT persisted across reloads — fresh tab/
        // refresh is a new identity.
        identity: ConsoleSession._mintIdentity(),
        displayName: undefined,
        aliasLabel: consoleAliasLabel,
        talkgroupKeys: tgKeyMap
    });

    let tones = [];
    if(configTones!==undefined)
    {
        for (let configTone of configTones) {
            tones.push(getTone(configTone.name,configTone.tgID,configTone.type,configTone.tone1,configTone.tone2,configTone.group,consoleSession))
        }
    }
    let channels = [];
    for (let configChannel of configChannels) {
        channels.push(getChannel(configChannel.id,configChannel.name,configChannel.key??systemKey,configChannel.group,configChannel.encryptionkey,0,configChannel.expanded,consoleSession));
    }

    // Wire ConsoleSession listeners so per-Channel UI state reflects per-TG
    // events from the single shared session.
    consoleSession.setListeners({
        onActive: ({ rid, ridByTg }) => {
            console.info("[dispatch] console active, rid=" + rid + " alias=" + consoleSession.consoleAlias
                + (ridByTg ? " (v2_legacy: per-channel RIDs)" : ""));
            for(const c of webconsole.channels) {
                // v2_legacy: legacy servers grant per subscriber, so each tile
                // keys under its OWN RID (sysID + 1 + index). Rev-7+ shares the
                // single console RID across every channel.
                const chRid = (ridByTg && ridByTg.get(c.tgID)) || rid;
                c.radioID = chRid;
                if(c.voice) {
                    if(typeof c.voice.setSubscriber === "function") {
                        c.voice.setSubscriber(chRid);
                    }
                    if(typeof c.voice.setAlias === "function") {
                        c.voice.setAlias(consoleSession.consoleAlias);
                    }
                }
            }
            webconsole.consoleRid = rid;
            webconsole.consoleAlias = consoleSession.consoleAlias;
            webconsole.poolExhausted = false;
            webconsole.sessionFailed = false;
            webconsole.sessionActive = true;
            webconsole.$forceUpdate && webconsole.$forceUpdate();
        },
        onSessionLost: () => {
            webconsole.sessionActive = false;
            webconsole.sessionFailed = true;
            // Visually reset any in-flight TX/RX UI for channels so the
            // dispatcher knows the session is gone. Rev 8 also force-
            // releases the outbound voice path: setPTT(false) stops the
            // encoder, setTalkgroup(0) clears the stamp so any race-frame
            // doesn't ship the dead RID/TG over a (still-attached but now
            // useless) socket.
            for(const c of webconsole.channels) {
                if(c.voice) {
                    try { c.voice.setPTT(false); } catch(_) {}
                    if(typeof c.voice.setTalkgroup === "function") {
                        try { c.voice.setTalkgroup(0); } catch(_) {}
                    }
                }
                c.tx = false;
                c.rx = false;
                c.preemptTx = false;
                c.displacedRid = undefined;
                c.displacedAlias = undefined;
                c.held = false;
                c.ptt = false;
                c.incomingSubCalls = [];
                c.status = "OFFLINE";
                if(c._keepaliveTimer) { clearInterval(c._keepaliveTimer); c._keepaliveTimer = null; }
                if(c._holdTimer) { clearTimeout(c._holdTimer); c._holdTimer = null; }
                if(c._currentStreamId) {
                    try { Tones.stopSustainedTone(c._currentStreamId); } catch(_) {}
                    c._currentStreamId = null;
                }
            }
            webconsole.$forceUpdate && webconsole.$forceUpdate();
        },
        onPoolExhausted: () => {
            webconsole.poolExhausted = true;
            webconsole.sessionActive = false;
            webconsole.sessionFailed = false;
            webconsole.$forceUpdate && webconsole.$forceUpdate();
        },
        onActivateFailed: () => {
            webconsole.sessionActive = false;
            // Auto-retry-driven activate failures count as Failed (banner
            // + alarm guard at the ConsoleSession layer). Distinct from
            // pool_exhausted which is terminal-until-manual-retry.
            webconsole.sessionFailed = true;
            webconsole.$forceUpdate && webconsole.$forceUpdate();
        },
        onChannelAnnounce: (packet) => {
            for(const c of webconsole.channels) { c.onChannelAnnounceForTG(packet); }
        },
        onChannelReleaseAnnounce: (packet) => {
            for(const c of webconsole.channels) { c.onChannelReleaseAnnounceForTG(packet); }
        },
        onIncomingSubscriberCall: (data, call) => {
            for(const c of webconsole.channels) { c.onIncomingSubscriberCallForTG(data, call); }
        },
        onIncomingSubscriberCallEnded: (data) => {
            for(const c of webconsole.channels) { c.onIncomingSubscriberCallEndedForTG(data); }
        },
        onEmergency: (data) => {
            for(const c of webconsole.channels) { c.onEmergencyForTG(data); }
        },
        onEmergencyClear: (data) => {
            for(const c of webconsole.channels) { c.onEmergencyClearForTG(data); }
        },
        onPatchAnnounce: (packet) => {
            console.debug("[dispatch] patch announce", packet);
        },
        onPatchReleaseAnnounce: (packet) => {
            console.debug("[dispatch] patch release announce", packet);
        },
        // Tones share one global oscillator, so ConsoleSession asks the UI
        // whether a TG is actually being monitored before sounding anything.
        // Without this, a tone on one channel is audible on every channel in
        // the view (including unmonitored ones) — every other TG-scoped event
        // gets this via its per-channel `...ForTG` handler. Answering false
        // before Vue is up is correct: nothing is monitored yet.
        isTalkgroupAudible: (tg) => {
            if(typeof webconsole === "undefined" || !webconsole || !webconsole.channels) { return false; }
            return webconsole.channels.some(
                c => c.monitored && c.tgID !== undefined && c.tgID.toString() === String(tg));
        },
        onSystemToneReceived: (tone) => {
            if(tone.type === "QCII") {
                Tones.generateQuikCallPage(tone.tone1, tone.tone2);
            } else {
                Tones.playAlertTone(tone.type);
            }
        }
    });

    // Activate the console session. Server replies with an offset → we then
    // confirm → affiliate. Calls happen before Vue init so the listeners
    // above can reference webconsole.channels safely once the snapshot lands.
    consoleSession.activate();

    let groups = configGroups;

    let audioDevices = await navigator.mediaDevices.enumerateDevices();

    // Initialize Vue instance first
    webconsole = new Vue({
        el: '#console',
        data: {
            desktopShortcut:-1,
            shortcutNextEntry:false,
            desktop:false,
            groups: groups,
            primary:-1,
            channels: channels,
            channelTones: channelTones,
            tones:tones,
            tonesPlaying:false,
            patches: [],
            patchingEnabled: false,
            newPatchTalkgroups: [],
            patchModalActive: false,
            emergencyMuted:false,
            settingsActive:undefined,
            // Rev 7 console session state — drives pool-exhausted banner +
            // TX-disabled UI when the dispatcher doesn't have a confirmed RID.
            consoleRid: 0,
            consoleAlias: "",
            sessionActive: false,
            poolExhausted: false,
            // Rev 8 reconnect-handling: true while the session is in the
            // Failed state (socket dropped, server reaped RID, etc.) and
            // the auto-reactivate loop is running. Distinct from
            // poolExhausted (terminal until manual retry). Drives the
            // FAILED banner + tile slash-through + PTT block.
            sessionFailed: false,
            audioDevicesHolder:audioDevices,
            config:{
                unselectAudioSeperate:false,
                unselectSpeaker:null,
                unselectVol:70,
                primarySpeaker:null,
                primaryVol:100
            }
        },
        methods: {
            forceUpdate:function(){
                this.$forceUpdate();
            },
            // Pool-exhausted recovery: retry activate. ConsoleSession resets
            // state and re-emits console_activate, then walks confirm→affiliate
            // again on success.
            retryConsoleActivate: function() {
                if(consoleSession) { consoleSession.retryActivate(); }
            },
            primaryPtt:function(state) {
                let primaryIndex = -1;
                for (let channelsKey in this.channels) {
                    if(this.channels[channelsKey].radioID==this.primary)
                    {
                        primaryIndex = channelsKey;
                    }
                }
                if(primaryIndex === -1)
                {
                    return;
                }

                if(!this.channels[primaryIndex].ptt)
                {
                    if(state===true)
                    {
                        this.channels[primaryIndex].togglePTT()
                    }
                }
                else
                {
                    if(state!==true)
                    {
                        this.channels[primaryIndex].togglePTT()
                    }
                }
            },
            clickConfigurePatches: async function(event) {
                await getPatches();
                await showPatchPanel();
            },
            showPatchPanel: async function() {
                await getPatches();

                var elem = document.querySelector('#patchModal');
                var instance = M.Modal.getInstance(elem);

                // Initialize modal if not already done
                if(!instance) {
                    var elems = document.querySelectorAll('#patchModal');
                    M.Modal.init(elems, {
                        onCloseEnd: () => {
                            this.patchModalActive = false;
                            this.newPatchTalkgroups = [];
                        }
                    });
                    instance = M.Modal.getInstance(elem);
                }

                // Open the modal
                if(instance) {
                    instance.open();
                    this.patchModalActive = true;
                } else {
                    console.error("Failed to initialize modal instance");
                }
            },
            closePatchPanel: function() {
                this.patchModalActive = false;
                this.newPatchTalkgroups = [];
            },
            isChannelInPatch: function(tgID) {
                // Check if channel is already in an active patch
                for(const patch of this.patches) {
                    if(patch.talkgroups.includes(tgID)) {
                        return true;
                    }
                }
                return false;
            },
            createPatch: async function() {
                if(this.newPatchTalkgroups.length < 2) {
                    alert("Please select at least 2 talkgroups to create a patch");
                    return;
                }

                // Create bidirectional patches between all talkgroups
                const talkgroups = this.newPatchTalkgroups;
                const patches = [];

                // Generate all pairs
                for(let i = 0; i < talkgroups.length; i++) {
                    for(let j = i + 1; j < talkgroups.length; j++) {
                        // Add both directions
                        patches.push({tg1: talkgroups[i], tg2: talkgroups[j]});
                        patches.push({tg1: talkgroups[j], tg2: talkgroups[i]});
                    }
                }

                // Send all patches to server
                let success = true;
                for(const patch of patches) {
                    await new Promise((resolve) => {
                        addPatch(systemKey, patch, (status) => {
                            if(status !== "OK") {
                                success = false;
                            }
                            resolve();
                        });
                    });
                }

                if(success) {
                    console.log("Patch created successfully");
                    await getPatches();
                    this.newPatchTalkgroups = [];
                } else {
                    alert("Failed to create patch");
                }
            },
            removePatchGroup: async function(patch) {
                // Remove all bidirectional patches for this group
                const talkgroups = patch.talkgroups;
                const patches = [];

                // Generate all pairs to remove
                for(let i = 0; i < talkgroups.length; i++) {
                    for(let j = i + 1; j < talkgroups.length; j++) {
                        // Add both directions
                        patches.push({tg1: talkgroups[i], tg2: talkgroups[j]});
                        patches.push({tg1: talkgroups[j], tg2: talkgroups[i]});
                    }
                }

                // Remove all patches from server
                let success = true;
                for(const patchObj of patches) {
                    await new Promise((resolve) => {
                        removePatch(systemKey, patchObj, (status) => {
                            if(status !== "OK") {
                                success = false;
                            }
                            resolve();
                        });
                    });
                }

                if(success) {
                    console.log("Patch removed successfully");
                    await getPatches();
                } else {
                    alert("Failed to remove patch");
                }
            },
            resetAllPatches: async function() {
                if(confirm("Are you sure you want to reset all patches?")) {
                    await new Promise((resolve) => {
                        resetPatches(systemKey, (status) => {
                            if(status === "OK") {
                                console.log("All patches reset");
                                getPatches();
                            } else {
                                alert("Failed to reset patches");
                            }
                            resolve();
                        });
                    });
                }
            },
            emgMute:function(){
                this.emergencyMuted = true;
            },
            showLog:function(){
                desktopAPI.showLog();
            },
            showRadios:function(){
                desktopAPI.showRadios();
            },
            setPrimary:async function(event){
                console.debug(event.target);
                let targetID = event.target.dataset.id;
                console.debug(`Set primary device to ${targetID}`)
                if(targetID==="default")
                {
                    return;
                }
                for (const d of this.audioDevicesHolder) {
                    console.debug(`compare [${d.deviceId}] to [${targetID}]`)
                    if(d.deviceId === targetID)
                    {
                        webconsole.config.primarySpeaker = d;
                        break;
                    }
                }
                refreshChannelAudio();
            },
            setUnselect:async function(event){
                let targetID = event.target.dataset.id;
                console.debug(`Set unselect device to ${targetID}`)
                if(targetID==="default")
                {
                    return;
                }
                for (const d of this.audioDevicesHolder) {
                    console.debug(`compare [${d.deviceId}] to [${targetID}]`)
                    if(d.deviceId === targetID)
                    {
                        webconsole.config.unselectSpeaker = d;
                        break;
                    }
                }
                refreshChannelAudio();
            },
            settings:async function(){
                if(this.settingsActive===undefined)
                {
                    var elems = document.querySelectorAll('#settingsModal');
                    var instances = M.Modal.init(elems, {
                        onCloseEnd: ()=>{
                            webconsole.settingsActive = false;
                        }
                    });
                    this.settingsActive=false;
                }
                let $settings = $("#settingsModal")
                if(this.settingsActive)
                {
                    $settings.modal('close');
                    $('.dropdown-trigger').dropdown();
                    this.settingsActive = false;
                }
                else
                {
                    $settings.modal('open');
                    this.settingsActive = true;
                }
            },
            setDesktopShortcut:async function(){
                desktopAPI.sendAlert("Keyboard Entry","Click out of the application then press the key to use for the global PTT shortcut");
                let nextKey = true;
                api.receive("keyevent",(e,type)=>{
                    if(nextKey && type==="down")
                    {
                        localStorage.setItem("desktopshortcut",e.keycode);
                        this.desktopShortcut = e.keycode;
                        nextKey = false;
                        desktopAPI.sendAlert("Keyboard Entry","Global keyboard shortcut set successfully.");
                    }
                })
            }
        }
    })

    // Set patching enabled after Vue instance is created
    webconsole.patchingEnabled = patchingEnabled;

    // If patching enabled, get current patches
    if(patchingEnabled) {
        await getPatches();
    }

    if(localStorage.key("desktopshortcut"))
    {
        webconsole.desktopShortcut = localStorage.getItem("desktopshortcut")
    }


    setTimeout(()=>{
        $('.dropdown-trigger').dropdown();
    },500)

    await Helper.sleep(500);
    loadingDiag.close();

    const view = urlParams.get('view');
    if(view==="tutorial")
    {
        introJs().onbeforechange(async (target, step, c, d) => {
            console.log("target",target);
            console.log("step",step);
            console.log("c",c);
            console.log("d",d);
            if(step === 5)
            {
                console.log("Enabling resource...")
                if(!webconsole.channels[0].enabled)
                {
                    await webconsole.channels[0].toggleMonitor(null);
                }
            }
            if(step===6)
            {
                emergencyAudio.volume = 0.1;
                webconsole.channels[0].eventCallback({
                    id:"emerg",
                    subscriber:1234
                })
            }
            if(step===8)
            {
                webconsole.emergencyMuted = true;
            }
            if(step===9)
            {
                emergencyAudio.volume = 0.25;
                webconsole.channels[0].clearEmergency({
                    currentTarget:target
                });
            }
            if(step===12)
            {
                document.querySelector("#console > div:nth-child(1) > nav > div.nav-content.red.darken-3 > ul > li:nth-child(2) > a").click();
            }
        }).setOptions({
            hidePrev: true,
            disableInteraction: true,
            exitOnEsc: false,
            exitOnOverlayClick: false,
            skipLabel: "",
            steps:
                [
                    {
                        intro: "Welcome to the SCNP25 Dispatch Panel! This tutorial will show you how to use the panel."
                    },
                    {
                        element: document.querySelector('#group-0 > div:nth-child(1) > div > div'),
                        intro: "This is a radio resource. This is how you interact with the radio system from the dispatch panel."
                    },
                    {
                        element: document.querySelector('#group-0 > div:nth-child(1) > div > div > button.btn.mon-button.grey'),
                        intro: "This button enables or disables a radio resource. If the button is green, the resource is enabled. If the button is grey, the resource is disabled. Disabled resources will not play audio and will not receive emergency alarms."
                    },
                    {
                        element: document.querySelector('#group-0 > div:nth-child(1) > div > div > button.btn.ptt-button'),
                        intro: "This button toggles PTT (Push-to-talk) for this radio resource."
                    },
                    {
                        element: document.querySelector('#group-0 > div:nth-child(1) > div > div > button.btn.hold-button.disabled'),
                        intro: "This button toggles a channel hold tone which plays every 10 seconds."
                    },
                    {
                        element: document.querySelector('#group-0 > div:nth-child(1) > div > div > button.btn.pri-button.disabled'),
                        intro: "This button selects this resource as the primary selected resource. When in desktop mode, the primary selected resource will be activated when the PTT keybind is used."
                    },
                    {
                        element: document.querySelector('#group-0 > div:nth-child(1) > div > div'),
                        intro: "When an emergency alarm is received, the resource will flash red/orange and play an audible alarm tone."
                    },
                    {
                        element: document.querySelector('#console > div:nth-child(1) > nav > div.nav-wrapper > div > ul > li:nth-child(1) > a'),
                        intro: "This button silences any active emergency alarms without knocking them down. The resource will remain flashing and other dispatchers will still hear the alarm."
                    },
                    {
                        element: document.querySelector('#group-0 > div:nth-child(1) > div > div > button.btn.emerg-button'),
                        intro: "This button clears (knocks down) an active emergency on this resource. Knocking down emergency alarms deactivates emergency alarm on the source radio and on all other users on the channel."
                    },
                    {
                        element: document.querySelector('#group-0 > div:nth-child(1) > div > div > button.btn.attn-button'),
                        intro: "This button allows you to play a tone on this radio resource"
                    },
                    {
                        element: document.querySelector('#group-0 > div:nth-child(1) > div > div > a'),
                        intro: "This button allows you to select the tone to play with the tone button"
                    },
                    {
                        element: document.querySelector('#console > div:nth-child(1) > nav > div.nav-content.red.darken-3 > ul'),
                        intro: "These tabs (if present) allow you to move between resource groups"
                    },
                    {
                        element: document.querySelector('#group-1 > div:nth-child(5) > div'),
                        intro: "This is a paging resource. Paging resources are used to send two-tone pages to users on the radio system."
                    },
                    {
                        element: document.querySelector('#group-1 > div:nth-child(5) > div > div > button:nth-child(3)'),
                        intro: "This button sends the page"
                    },
                    {
                        element: document.querySelector('#group-1 > div:nth-child(5) > div > div > button:nth-child(4)'),
                        intro: "This button adds the page to a multi-page group. Multi-page groups allow you to send multiple pages at once. Once the pages are added, you can send them by pressing the page button on any of them."
                    },
                    {
                        intro: "You may try features on this test console to learn how they work - it's not connected to your live console and won't affect anyone else. Enjoy!"
                    },
                ]
        }).start();
    }


    try {
        if (desktop) {
            desktopAPI.sendNotification("Loaded", "Dispatch panel load complete")
        }
    }
    catch(e)
    {

    }
}
let emergencyAudio = new Audio('audio/mcc7550_emerg.wav');
emergencyAudio.loop = true;

let emergActive = false

setInterval(()=>{
    let emergencyActive = false
    for(let channel of webconsole.channels)
    {
        if(channel.emg!=0)
        {
            emergencyActive = true
        }
    }
    if(emergencyActive && !emergActive && !webconsole.emergencyMuted)
    {
        emergencyAudio.play()
        emergActive = true;
    }
    else if(!emergencyActive && emergActive || webconsole.emergencyMuted)
    {
        emergencyAudio.pause();
        emergActive = false;
    }
},500)

initialSetup();

window.addEventListener('keydown',(e)=>{
    console.log(e);
})

// Best-effort tab-close cleanup: drop any in-flight hold-to-talk streams and
// fire console_deactivate so the server returns our RID to the pool promptly
// (vs waiting for heartbeat timeout).
window.addEventListener('beforeunload', () => {
    if(webconsole && webconsole.channels) {
        for(const c of webconsole.channels) {
            if(c._currentStreamId && consoleSession) {
                try { consoleSession.broadcastToneStop(c._currentStreamId); } catch(_e) {}
            }
        }
    }
    if(consoleSession) {
        try { consoleSession.deactivate(); } catch(_e) {}
    }
});